'use strict';

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _button = require('../../../common/components/button');

var _button2 = _interopRequireDefault(_button);

var _signupOrLoginButton = require('./signup-or-login-button');

var _signupOrLoginButton2 = _interopRequireDefault(_signupOrLoginButton);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

module.exports = _react2['default'].createClass({
    displayName: 'SEO CTA Buttons',

    signupOrLoginButtonProps: function signupOrLoginButtonProps() {
        return {
            classNames: 'm-marketing-page--button',
            styleAttributes: 'width: 274px',
            buttonText: this.props.signupButtonText
        };
    },
    secondButtonProps: function secondButtonProps() {
        return {
            buttonText: this.props.secondButtonText,
            buttonLink: this.props.secondButtonUrl,
            buttonColor: 'plume',
            buttonTextColor: 'goldenrod',
            buttonTextUppercase: false,
            buttonBorderColor: 'goldenrod',
            buttonHoverColor: 'goldenrod',
            buttonHoverTextColor: 'white'
        };
    },
    render: function render() {
        var props = this.props;
        return _react2['default'].createElement(
            'div',
            null,
            _react2['default'].createElement(
                'div',
                { className: 'columns small-12 small-centered small-text-center' },
                _react2['default'].createElement(
                    'div',
                    { className: 'l-padding-t-40 l-padding-b-15' },
                    _react2['default'].createElement(
                        'h2',
                        { className: 'm-marketing-page--get-started' },
                        props.title
                    ),
                    _react2['default'].createElement(
                        'h4',
                        { className: 'm-marketing-page--subheader', style: { maxWidth: 1100 } },
                        props.subtitle
                    )
                )
            ),
            _react2['default'].createElement(
                'div',
                { className: 'row l-padding-b-30' },
                _react2['default'].createElement(
                    'div',
                    { className: 'small-12 columns text-center' },
                    _react2['default'].createElement(
                        'div',
                        { className: 'm-marketing-page--button-inline' },
                        _react2['default'].createElement(_signupOrLoginButton2['default'], _extends({}, this.signupOrLoginButtonProps(), props))
                    ),
                    _react2['default'].createElement(
                        'div',
                        { className: 'm-marketing-page--button-inline', id: 'set-up-a-demo-link' },
                        _react2['default'].createElement(_button2['default'], _extends({}, this.secondButtonProps(), props))
                    )
                )
            )
        );
    }
});


/*****************
 ** WEBPACK FOOTER
 ** ./src/landing-pages/components/common/cta-buttons.jsx
 ** module id = 1213
 ** module chunks = 0
 **/